module.exports = __webpack_public_path__ + "static/media/18ECA23.a821c857.jpg";